// @ts-nocheck
import { createHandlerChainRunner, Handler } from "@toolkit/Modules/client-framework/HandlerCreator";

export type SetIsEditingDatesParameter = {
    isEditingDate?: boolean;
};

type HandlerType = Handler<SetIsEditingDatesParameter>;

export const DispatchSetIsEditingDate: HandlerType = props => {
    props.dispatch({
        type: "Greif/Pages/CartRequestedDate/SetIsEditingDate",
        isEditingDate: props.parameter.isEditingDate,
    });
};

export const chain = [DispatchSetIsEditingDate];

const setIsEditingDate = createHandlerChainRunner(chain, "SetIsEditingDate");

export default setIsEditingDate;
